import React from 'react';
import './App.css';
import Newsapp from './components/Newsapp';

function App() {

  return (
    <>
   <Newsapp/>

   </>
  );
}

export default App;
